import {Component, inject} from '@angular/core';
import {DatePipe} from '@angular/common';
import {TranslationService} from '../services/translation/translation.service';

@Component({
  selector: 'af-footer',
  imports: [
    DatePipe
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  protected readonly translationService = inject(TranslationService);
  protected readonly date = Date.now();
}
